import React from "react"
import NumerableIconButton from "../../NumerableIconButton"
import { JARGON, LAYOUT } from "../../../modules/constants"
import { formatDate } from "../../../modules/utilities"
import BookOutlinedIcon from "@mui/icons-material/BookOutlined"

const getLink = (pageNo, reportUrl) => pageNo
    ? reportUrl.endsWith(".xhtml")
        ? `${reportUrl}#pf${pageNo.toString(16)}`
        : `${reportUrl}#page=${pageNo}`
    : null

const getbuttonProps = ({ label, link, paddingLeft = LAYOUT.COLUMN_PADDING, paddingRight = LAYOUT.COLUMN_PADDING, page = null }) => ({
    disabled: !link,
    icon: <BookOutlinedIcon />,
    label,
    handleClick: () => { window.open(link, "_blank") },
    paddingLeft,
    paddingRight,
    width: "",
    fontWeight: "normal",
    // Use 'label' if 'page' not supplied
    tipEnabled: `external link to ${page ?? label} page of last Annual Report`,
})

function AnnualReportMenu(props) {
    // console.log('AnnualReportMenu props:', props)

    const { externalLinks, hubData, enablePages, portrait } = props
    const { annualReport } = hubData.lseProps
    const { pages } = annualReport

    const baseUrl = annualReport?.url || hubData.pdfLink
    const boardPageLink = getLink(pages?.board, baseUrl)
    const payPageLink = getLink(pages?.pay, baseUrl)
    const revenuePageLink = getLink(pages?.revenue, baseUrl)
    const disabled = !externalLinks || !baseUrl
    const label = `Annual Report (${formatDate(annualReport?.dates?.accountsDate, true)})`

    const buttonProps = {
        titlePage: {
            ...getbuttonProps({
                link: baseUrl,
                label,
                paddingLeft: LAYOUT.MENU_FIRST_PADDING,
                // Longest label in this menu column - needs all available width to avoid wrapping.
                paddingRight: 0,
                page: "Title" // Overrides 'label' used in 'tipEnabled'
            }),
            // Give this button a fixed full-width footprint (rather than sizing to its own
            // content, like the other buttons in this menu do) so that shortening its padding
            // to fit the longer label doesn't shrink its box and shift boardPage/payPage/revenuePage.
            width: "100%",
        },
        boardPage: getbuttonProps({ link: boardPageLink, label: "Board" }),
        payPage: getbuttonProps({ link: payPageLink, label: "Remuneration" }),
        revenuePage: getbuttonProps({ link: revenuePageLink, label: "Income" }),
    }

    const annualReportButtonLabel = () => {

        const prefix = hubData.lseProps
            ? hubData.periodEndOn
                ? "Annual Report"
                : "Initial Accounts"
            : "Last Accounts"

        const formattedDate = annualReport?.dates?.accountsDate
            ? ` (${formatDate(annualReport.dates.accountsDate, true)})`
            : hubData.periodEndOn
                ? ` (${formatDate(hubData.periodEndOn, true)})` // NB: 'madeUpTo' depricated
                : ""

        return disabled ? prefix : `${prefix}${formattedDate}`
    }

    const tipEnabled = "external link to last Annual Report"
    const annualReportButton = {
        disabled,
        tipEnabled,
        tipDisabled: !externalLinks
            ? tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY
            : hubData.lseProps
                ? "no Annual Report available"
                : "no accounts available",
        icon: <BookOutlinedIcon />,
        label: annualReportButtonLabel(),
        handleClick: () => { window.open(baseUrl, "_blank") },
        // Full width, no right padding: the label (e.g. "Annual Report (31 Mar 2026)") is the
        // longest in this menu column, so it needs all the horizontal room it can get to avoid wrapping.
        paddingRight: 0,
        width: "100%",
        fontWeight: "normal",
    }

    return (
        <div>
            {enablePages && pages && <React.Fragment>
                <NumerableIconButton item={buttonProps.titlePage} portrait={portrait} />
                <NumerableIconButton item={buttonProps.boardPage} portrait={portrait} />
                <NumerableIconButton item={buttonProps.payPage} portrait={portrait} />
                <NumerableIconButton item={buttonProps.revenuePage} portrait={portrait} />
            </React.Fragment>
            }
            {(!enablePages || !pages) && <NumerableIconButton item={annualReportButton} portrait={portrait} />}
        </div>
    )
}

export default AnnualReportMenu

